import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { SenzaSezioni } from "@/components/auth/ErroriDiSistema";
import { arrivoDi, puoAprire } from "@/lib/accessi";

/**
 * La guardia delle rotte: un indirizzo che il ruolo non ha nel menu rimanda alla
 * sua pagina d'arrivo. Sta DENTRO `ProtectedRoute`, quindi quando decide il ruolo
 * è già noto (il profilo in volo o mancante lo gestisce il cancello prima).
 *
 * È una comodità, non la protezione: i dati li chiudono il server e la RLS.
 * La mappa sta in `lib/accessi.js`.
 */
export default function GuardiaRuolo({ children }) {
  const { profile, signOut } = useAuth();
  const { pathname } = useLocation();
  const ruolo = profile?.ruolo;
  const spente = profile?.sezioni_spente;
  const arrivo = arrivoDi(ruolo, spente);

  // Un ruolo che la mappa non conosce: niente rimbalzo (non c'è dove mandarlo,
  // e un rimando su se stesso girerebbe all'infinito). Lo si dice e si esce.
  if (!arrivo) return <SenzaSezioni onEsci={() => signOut?.()} />;

  if (!puoAprire(ruolo, pathname, spente)) return <Navigate to={arrivo} replace />;
  return children;
}

/** La porta `/`: rimanda alla pagina d'arrivo del ruolo. */
export function ArrivoDelRuolo() {
  const { profile } = useAuth();
  return <Navigate to={arrivoDi(profile?.ruolo, profile?.sezioni_spente) || "/login"} replace />;
}
